
import React from 'react'
import Layout from '../../../components/layouts/layout.comp'
import { useTranslation } from '../../../core/translation.core';
import useAddSalesLocation from '../../../hooks/salesLocation/useAddSales.hook';
import { LabelAndInput } from '../../../components/reuseables/form.comp';
import Spinner from '../../../components/loaders/Spinner';
import { EditorSection, Title } from '../../../components/reuseables/editor.comp';
import { LocalInputDefaultLocale } from '../../../components/locale/locale.comp';

export default function AddLocation() {
  const { t, msg } = useTranslation();
  const { methods, formhandler, onSubmit } = useAddSalesLocation()

  return (
    <Layout
      title={t(msg.ship.location)}
    >
      <div className='container mx-auto'>
        <h1>Add Location</h1>
        {formhandler.isError && (
          <p id="err" className="text-red-700">
            {formhandler.error.message}
          </p>
        )}

        {formhandler.isSuccess && (
          <p id="err" className="text-green-400">
            {t(msg.import.success)}
          </p>
        )}

        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <EditorSection>
            <Title>{t(msg.customer.name)}</Title>
            <LocalInputDefaultLocale register={methods.register} fieldName="name" />
          </EditorSection>
          <EditorSection>
            <Title>{t(msg.ship.addr)}</Title>
            <LocalInputDefaultLocale register={methods.register} fieldName="address" />
          </EditorSection>
          <LabelAndInput topLabelCss="pb-2" label="Opening Hours" type="text" register={methods.register} fieldName="openingHour" />
          <LabelAndInput topLabelCss="pb-2" label="Tel" type="text" register={methods.register} fieldName="tel" />
          <LabelAndInput topLabelCss="pb-2" label="Whatsapp" type="url" register={methods.register} fieldName="whatsapp" />
          <LabelAndInput topLabelCss="pb-2" label="Website" type="url" register={methods.register} fieldName="website" />
          <LabelAndInput topLabelCss="pb-2" label="Map URL" type="url" register={methods.register} fieldName="mapUrl" />
          <button
            type='submit'
            className="flex items-center gap-2 text-white bg-blue-400 px-4 py-2 mt-2"
          >
            Submit
            {formhandler.isPending &&
              <Spinner />
            }
          </button>
        </form>
      </div>
    </Layout>
  )
}